'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const css = require('./personalizationOverlayStyle.scss');
const ArrowSvgRight = require('dibs-vg/dist/react/arrow-right');
const classnames = require('classnames');

function PersonalizationSliderOverlay(props) {

    const containerClass = classnames(props.additionalClassName, css.overlay, {
        [css.isFlipped]: props.isLeft
    });

    return (
        <div className={containerClass} onClick={props.onClick}>
            <ArrowSvgRight className={css.overlayArrow} />
        </div>
    );
}

PersonalizationSliderOverlay.propTypes = {
    additionalClassName: PropTypes.string,
    isLeft: PropTypes.bool,
    onClick: PropTypes.func
};

PersonalizationSliderOverlay.defaultProps = {
    onClick: () => {}
};

module.exports = PersonalizationSliderOverlay;



// WEBPACK FOOTER //
// ./assets/js/home/components/personalization/PersonalizationOverlay.jsx